export default __webpack_public_path__ + "static/media/omitb002.07d675fc.jpg";